'use client';

import cn from 'classnames';

import { getENV } from '../../../../utils/env';
import PrivacyOptionsIcon from './privacyoption.icon.svg';
import './OneTrustButton.scss';

type OneTrustButtonProps = {
    label?: string;
    className?: string;
};

export const OneTrustButton = ({ label = 'Your Privacy Choices', className }: OneTrustButtonProps) => {
    const handleClick = () => {
        if (window?.Optanon?.ToggleInfoDisplay) {
            window.Optanon.ToggleInfoDisplay();
            return;
        }

        globalThis.location.href = getENV('NEXT_PUBLIC_ONETRUST_FALLBACK_URL');
    };

    return (
        <button type="button" id="ot-sdk-btn" className={cn('ot-custom-button', className)} onClick={handleClick}>
            <span className="ot-custom-button__label">{label}</span>
            <PrivacyOptionsIcon aria-hidden="true" focusable="false" height="14" />
        </button>
    );
};
